import { useContext } from "react";
import Mp3ControllerContext from "../contexts/Mp3ControllerContext";

export function useMp3Controller() {
  return useContext(Mp3ControllerContext);
}
